module.exports = __webpack_public_path__ + "img/2011 feuerwehrausflug heimatmuseum 002.3f020716.jpg";